import { useMemo, useRef, useCallback } from "react";
import { trackInteraction } from "../lib/metrics";

function storageKey({ sessionCode, stage, playerId }) {
  return `inspected:${sessionCode}:s${stage}:p${playerId}`;
}

function loadSet(key) {
  try {
    const raw = localStorage.getItem(key);
    const arr = raw ? JSON.parse(raw) : [];
    return new Set(Array.isArray(arr) ? arr : []);
  } catch {
    return new Set();
  }
}

function persistSet(key, set) {
  try {
    localStorage.setItem(key, JSON.stringify([...set]));
  } catch { }
}

export function useInspections({ sessionCode, stage, playerId }) {
  const sid = sessionCode ?? "";
  const stg = Number(stage);
  const pid = Number(playerId);

  const key = useMemo(() => {
    if (!sid || !Number.isFinite(stg) || !Number.isFinite(pid)) return "";
    return storageKey({ sessionCode: sid, stage: stg, playerId: pid });
  }, [sid, stg, pid]);

  // store par key (supporte changement de session / player)
  const storeRef = useRef(new Map());
  const keyRef = useRef("");

  // IMPORTANT: synchro immédiate (pas d’effet)
  if (key && keyRef.current !== key) {
    keyRef.current = key;
    if (!storeRef.current.has(key)) {
      storeRef.current.set(key, loadSet(key));
    }
  }

  const markInspectedOnce = useCallback(
    (objectId) => {
      const k = keyRef.current;

      if (!k) {
        console.warn("[inspections] key missing -> skip", {
          sessionCode,
          stage,
          playerId,
          objectId,
        });
        return false;
      }

      if (!objectId) return false;

      const set = storeRef.current.get(k) || new Set();
      if (!storeRef.current.has(k)) storeRef.current.set(k, set);

      if (set.has(objectId)) return false;

      set.add(objectId);
      persistSet(k, set);
      persistSet(k, set);

      // Notifie le même onglet (storage event ne fire pas ici)
      window.dispatchEvent(
        new CustomEvent("inspections:changed", { detail: { storageKey: k } })
      );


      console.log("[INTERACTIONS] +1", { sessionCode: sid, stage: stg, playerId: pid, objectId });

      trackInteraction({
        sessionCode: sid,
        stage: stg,
        playerId: pid,
        objectId,
      });

      return true;
    },
    [sid, stg, pid, sessionCode, stage, playerId]
  );

  const resetInspections = useCallback(() => {
    const k = keyRef.current;
    if (!k) return;
    storeRef.current.set(k, new Set());
    try {
      localStorage.removeItem(k);
    } catch { }
  }, []);

  return { markInspectedOnce, resetInspections };
}
